"use strict";
/*
 * Created on 19. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractReleaseConverterImpl_1 = require("./AbstractReleaseConverterImpl");
/**
 * Release converter.
 *
 * @author Radek Beran
 */


var ReleaseConverter =
/*#__PURE__*/
function (_AbstractReleaseConve) {
  _inherits(ReleaseConverter, _AbstractReleaseConve);

  function ReleaseConverter(releasePartConverter, selloutReleasePartConverter, userInfoConverter, editInfoConverter, validationResultConverter, realImpactValueConverter, selloutItemFilterConverter, selloutReleaseSnapshotConverter) {
    var _this;

    _classCallCheck(this, ReleaseConverter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseConverter).call(this, releasePartConverter, selloutReleasePartConverter, userInfoConverter, editInfoConverter, validationResultConverter, realImpactValueConverter, selloutItemFilterConverter, selloutReleaseSnapshotConverter));
    _this.releasePartConverter = releasePartConverter;
    _this.selloutReleasePartConverter = selloutReleasePartConverter;
    _this.userInfoConverter = userInfoConverter;
    _this.editInfoConverter = editInfoConverter;
    _this.validationResultConverter = validationResultConverter;
    _this.realImpactValueConverter = realImpactValueConverter;
    _this.selloutItemFilterConverter = selloutItemFilterConverter;
    _this.selloutReleaseSnapshotConverter = selloutReleaseSnapshotConverter;
    return _this;
  }

  return ReleaseConverter;
}(AbstractReleaseConverterImpl_1.AbstractReleaseConverterImpl);

exports.ReleaseConverter = ReleaseConverter;